module.exports = __webpack_public_path__ + "static/media/gsd8.ab4b7f75.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/fr/gsd8.png
// module id = 141
// module chunks = 0